<ng-container *transloco="let t">
    <div class="fixed bottom-4 z-99999"
         [ngClass]="lang==='ar'?'left-4':'right-4'">
        <button (click)="toggleChat()" mat-icon-button
                class="bg-primary text-white p-3 rounded-full shadow-lg hover:scale-110 duration-200">
            <mat-icon class="text-white">chat</mat-icon>
        </button>
    </div>

    <!-- Chat Box -->
    <div *ngIf="isOpen" @chatBoxAnimation
         class="fixed bottom-20 max-w-full w-full sm:w-[450px] h-[570px] bg-card border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden flex flex-col"
         [ngClass]="lang==='ar'?'left-0 sm:left-4':'right-0 sm:right-4'">
        <div class="flex justify-between items-center p-2 border-b bg-primary">
            <p class="font-bold text-lg text-white">{{t('SAI Assistant')}}</p>
            <button (click)="toggleChat()">
                <mat-icon class="text-white">close</mat-icon>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto">
            <app-tutorial></app-tutorial>
        </div>
    </div>
</ng-container>